import { Grid } from "antd-mobile"
import { useEffect, useState } from "react"
import { VictoryChart, VictoryLine } from "victory"
import { DATA_TYPE, getDataByDate } from "../../api/userData"

// const TEST_DATA = [
//   { x: "1/02/23", y: 2 },
//   { x: "2/02/23", y: 3 },
//   { x: "3/02/23", y: 5 },
//   { x: "4/02/23", y: 4 },
//   { x: "5/02/23", y: 7 },
//   { x: "6/02/23", y: 7 },
//   { x: "7/02/23", y: 7 },
// ]
const TEST_DATA = []
export const WATER_COLOR = "#3fd2e4" // TODO move to constans
export const FOOD_COLOR = "#86D27B"

function Statistic() {
  const [kkalData, setKkalData] = useState(TEST_DATA)
  const [waterData, setWaterData] = useState(TEST_DATA)

  useEffect(() => {
    const waterResult = []
    const kkalResult = []

    for (let i = 5; i >= 0; i--) {
      let totalWater = 0
      let totalKkal = 0
      const date = new Date()
      date.setDate(date.getDate() - i)
      getDataByDate(DATA_TYPE.WATER, date.toLocaleDateString())?.forEach(
        (item) => {
          totalWater += Number(item.value)
        }
      )
      const localDate = date.toLocaleDateString(navigator.language, {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit",
      })
      waterResult.push({ x: localDate, y: totalWater })

      getDataByDate(DATA_TYPE.DIET, date.toLocaleDateString())?.forEach(
        (item) => {
          const [, cal] = String(item.name).split("|")
          totalKkal += (Number(cal) * item.weight) / 100
        }
      )
      kkalResult.push({ x: localDate, y: totalKkal })
    }

    setWaterData(waterResult)
    setKkalData(kkalResult)
  }, [])

  console.log(kkalData)

  return (
    <Grid columns={12} style={{ marginLeft: 16, marginRight: 16 }}>
      <Grid.Item span={12}>
        <p>Потребление калорий (ккал.)</p>
      </Grid.Item>
      <Grid.Item span={12}>
        <VictoryChart>
          <VictoryLine
            style={{
              data: { stroke: FOOD_COLOR },
              parent: { border: "1px solid #ccc" },
            }}
            data={kkalData}
          />
        </VictoryChart>
      </Grid.Item>
      <Grid.Item span={12}>
        <p>Потребление воды (мл.)</p>
      </Grid.Item>
      <Grid.Item span={12}>
        <VictoryChart>
          <VictoryLine
            style={{
              data: { stroke: WATER_COLOR },
              parent: { border: "1px solid #ccc" },
            }}
            data={waterData}
          />
        </VictoryChart>
      </Grid.Item>
    </Grid>
  )
}

export default Statistic
